module.exports = __webpack_public_path__ + "img/TROC-colors.9683dea6.png";